import gql from 'graphql-tag'

const mutation = gql`
mutation changeDeviceType(
	$cashRegisterId: ID!,
	$deviceType: cashRegisterType!
) {
	cashAssist {
	  changeDeviceType(
      cashRegisterId: $cashRegisterId,
      newDeviceType: $deviceType
    ) {
	  	id
			mod_ver
			deviceType
			hardwareId
			isSynced
	  }
	}
}
`

export default mutation
